import { getPriceForCartByType } from '@/features/games/shared/helpers/get-price-by-type';
import { TrackViewItemParams } from '@/features/gtm/shared/helper/track-view-item';
import { CartProductItem } from '@/features/cart/shared/types/cart.types';
import { PromotionData } from '@/shared/types/prices';

function calcDiscount(price: number, originalPrice?: number): number | undefined {
  if (!originalPrice || originalPrice <= price) return undefined;
  return Math.round((originalPrice - price) * 100) / 100;
}

export const cartItemToEcommerceParams = (
  cartItem: CartProductItem,
  isWildMember: boolean,
  promotion?: PromotionData,
): TrackViewItemParams => {
  const buyOption = cartItem.gameData?.purchaseOptions?.find((opt) => opt.type === 'buy');
  const rentOption = cartItem.gameData?.purchaseOptions?.find((opt) => opt.type === 'rent');
  const priceData = cartItem.optionType === 'buy' ? buyOption?.prices : rentOption?.prices;
  let salePrice;
  let standardPriceWithoutMembership;
  if (priceData) {
    salePrice = getPriceForCartByType(priceData, 'sale');
    standardPriceWithoutMembership = getPriceForCartByType(priceData, 'price');
  }
  const standardPrice = standardPriceWithoutMembership
    ? standardPriceWithoutMembership
    : cartItem.price;
  const memberPrice = isWildMember ? cartItem.price : standardPrice;
  let discountReason: 'sale' | 'membership' | 'promotion' | undefined = undefined;
  let discount = 0;
  let originalPrice = standardPrice?.value || 0;
  const currency = standardPrice?.currencyCode || 'USD';
  let price = standardPrice?.value || 0;
  if (isWildMember) {
    discountReason = 'membership';
    discount = calcDiscount(memberPrice?.value || 0, standardPrice?.value || 0) || 0;
    price = memberPrice?.value || 0;
  }
  if (salePrice?.value) {
    discountReason = 'sale';
    discount = calcDiscount(salePrice.value!, salePrice.previousValue!) || 0;
    price = salePrice.value;
    originalPrice = salePrice.previousValue!;
  }

  if (promotion?.promotionalPrices?.length) {
    const currentPromotionPrice = getPriceForCartByType(promotion?.promotionalPrices, 'current');
    discountReason = 'promotion';
    discount = calcDiscount(currentPromotionPrice?.value || 0, standardPrice?.value || 0) || 0;
    price = currentPromotionPrice?.value || 0;
    originalPrice = standardPrice?.value || 0;
  }

  return {
    itemName: cartItem.gameData?.name || '',
    itemId: cartItem.gameData?.sku || '',
    categories: cartItem.gameData?.categories?.map((cat) => cat.name),
    variant: cartItem?.optionType === 'rent' ? 'rental' : 'purchase',
    itemBrand: cartItem.gameData?.developer?.value || '',
    productType: cartItem.gameData?.productType || 'download',
    discountReason: discountReason,
    discount,
    originalPrice,
    currency,
    price,
  };
};
